import React, { useState } from 'react';
import Image from 'next/image';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'next-i18next';
interface Tab {
  name: string;
  content: string;
  image: string;
}
const tabs: Tab[] = [{
  name: 'text-tab-about',
  content: 'text-tab-about-content',
  image: '/assets/images/about/about-tab-1.jpeg'
}, {
  name: 'text-tab-mission',
  content: 'text-tab-mission-content',
  image: '/assets/images/forever-placeholder.jpg'
}, {
  name: 'text-tab-way',
  content: 'text-tab-way-content',
  image: '/assets/images/forever-placeholder.jpg'
}];
const Tabs = () => {
  const [activeTab, setActiveTab] = useState<Tab>(tabs[0]);
  const {
    t
  } = useTranslation('common');
  const handleTabClick = (tab: Tab) => {
    setActiveTab(tab);
  };
  return <div className="w-full py-12 bg-white dark:bg-zinc-950 flex flex-col items-center" data-sentry-component="Tabs" data-sentry-source-file="tab.tsx">
      <div className="flex flex-wrap justify-center mb-12 space-x-2 md:space-x-8 p-2 md:p-4 text-sm rounded-full border border-neutral-700 bg-neutral-600 dark:dark:bg-neutral-900 overflow-x-auto scrollbar-hide">
        {tabs.map(tab => <div key={tab.name} className="relative px-3 md:px-6 py-2 md:py-3 cursor-pointer text-yellow whitespace-nowrap" onClick={() => handleTabClick(tab)}>
            <span className={`relative z-10 ${activeTab.name === tab.name ? 'text-yellow-500' : 'text-gray-300'}`}>
            {t(tab.name)}
            </span>
            {activeTab.name === tab.name && <motion.div layoutId="activeTab" className="absolute inset-0 rounded-full bg-neutral-800" transition={{
          type: 'spring',
          stiffness: 500,
          damping: 30
        }} style={{
          boxShadow: '0 0 15px rgba(255, 215, 0, 0.6), 0 0 30px rgba(255, 215, 0, 0.4), 0 0 45px rgba(255, 215, 0, 0.2)'
        }} />}
          </div>)}
      </div>
      <div className="bg-neutral-900 rounded-3xl shadow-lg p-4 md:p-8 flex flex-col md:flex-row items-center w-full max-w-6xl min-h-[450px] transition-all duration-500">
        <AnimatePresence mode="wait" data-sentry-element="AnimatePresence" data-sentry-source-file="tab.tsx">
          {tabs.map(tab => activeTab.name === tab.name && <motion.div key={tab.name} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.5
        }} className="flex flex-col md:flex-row items-center w-full">
                <div className="flex flex-col items-start w-full md:w-1/2 p-4 md:p-8">
                  <div className="text-gray-50 text-xl md:text-3xl font-semibold mb-4">{t(tab.name)}</div>
                  <div className="text-gray-300 text-base md:text-lg mb-4">{t(tab.content)}</div>
                </div>
                <div className="w-full md:w-1/2 p-4 md:p-8">
                  <div className="rounded-3xl overflow-hidden shadow-md">
                    <Image className="w-full h-full object-cover" src={tab.image} alt={tab.name} width={619} height={464} />
                  </div>
                </div>
              </motion.div>)}
        </AnimatePresence>
      </div>
    </div>;
};
export default Tabs;